module.exports = __webpack_public_path__ + "static/media/road_side_assistence.68f3f99b.svg";